import { calculateCTR, formatCTR } from 'utils/stats'

export const getCtr = ({
  usersTotal,
  deliveredUniqueUsers,
}: {
  usersTotal: number
  deliveredUniqueUsers: number
}) => {
  const ctrValue = calculateCTR(usersTotal, deliveredUniqueUsers)

  return formatCTR(ctrValue > 100 ? 100 : ctrValue)
}
